import React from 'react';
import { Box, Typography } from '@mui/material';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {
    AccountCircle,
    LibraryAdd,
    Search,
    School,
    Timeline,
    Share,
} from '@mui/icons-material';

// Define steps for Uben's learning journey
const steps = [
    { 
        label: 'Step 1', 
        icon: <AccountCircle />, 
        title: 'Create Your Free Account', 
        subtitle: 'Sign up in seconds and personalize your learning experience with your goals and preferences', 
        date: 'Get Started' 
    },
    { 
        label: 'Step 2', 
        icon: <LibraryAdd />, 
        title: 'Create or Import Flashcard Decks', 
        subtitle: 'Build your own decks of flashcards for any subject, or import existing ones from Anki - our smart system adapts to your learning style', 
        date: 'Build Your Content' 
    },
    { 
        label: 'Step 3', 
        icon: <Search />, 
        title: 'Discover Ready-Made Decks', 
        subtitle: 'Browse community-created decks covering languages, sciences, history, coding, and more - add them to your collection instantly', 
        date: 'Find What You Need' 
    },
    { 
        label: 'Step 4', 
        icon: <School />, 
        title: 'Study with Smart Spaced Repetition', 
        subtitle: 'Practice with smart algorithm that prioritize what you need to review, optimizing retention and minimizing study time', 
        date: 'Learn Efficiently' 
    },
    { 
        label: 'Step 5', 
        icon: <Timeline />, 
        title: 'Track Your Progress & Streaks', 
        subtitle: 'Watch your knowledge grow with detailed stats, daily streaks, mastery levels, and beautiful progress visualizations', 
        date: 'See Your Growth' 
    },
    { 
        label: 'Step 6', 
        icon: <Share />, 
        title: 'Share & Join the Community', 
        subtitle: 'Share your decks with others, get help in our Discord, and contribute to the growing library of learning resources', 
        date: 'Connect & Contribute' 
    },
];

function Roadmap() {
    return (
        <Box sx={{ width: '100%', padding: '2rem', color: '#ffffffff' }}>
            <Typography variant="h2" gutterBottom align="center" sx={{ mb: 4, fontWeight: 'bold' }}>
                Master Any Subject with Uben's Smart Learning System
            </Typography>
            <Typography variant="h5" align="center" sx={{ mb: 6, color: 'rgba(255,255,255,0.8)', maxWidth: '800px', mx: 'auto', lineHeight: 1.6 }}>
                From languages to sciences, coding to history - learn anything with our smart flashcard system that remembers what you know and focuses on what you need to review
            </Typography>
            <VerticalTimeline>
                {steps.map((step, index) => (
                    <VerticalTimelineElement
                        key={index}
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: index % 2 === 0 ? 'rgb(33, 150, 243)' : '#fff', color: index % 2 === 0 ? '#fff' : '#3f4144' }}
                        contentArrowStyle={{ borderRight: index % 2 === 0 ? '7px solid  rgb(33, 150, 243)' : '7px solid #fff' }}
                        date={step.date}
                        iconStyle={{ background: index % 2 === 0 ? 'rgb(33, 150, 243)' : '#fff', color: index % 2 === 0 ? '#fff' : '#3f4144' }}
                        icon={step.icon}
                    >
                        <h3 className="vertical-timeline-element-title">{step.title}</h3>
                        <h4 className="vertical-timeline-element-subtitle" style={{ marginTop: '0.5rem' }}>{step.subtitle}</h4>
                    </VerticalTimelineElement>
                ))}
            </VerticalTimeline>
        </Box>
    );
}

export default Roadmap;
